import styled, { createGlobalStyle } from "styled-components"
import { up } from "styled-breakpoints"

export const GlobalStyles = createGlobalStyle`



body{

  background-color: #0000000a;
  font-family: 'Open Sans Condensed', sans-serif; 
  overflow-y:auto;
  height: calc(var(--vh, 1vh) * 100);

}

:root{
  --selected-color:#4fb9e7;
  --white-color: #fff;
}

.goBagContainer{
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  ${up("lg")}{
   padding:0;
}


}


.goBagHeader {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  margin:30px auto 0;

  ${up("lg")}{
    grid-template-columns: min-content 1fr;
}
  

&.-thank-you{
  width:200px
}

  
  img{
    width: 102px;
  height: 50px;
  object-fit:contain;

${up("md")}{
  width: 204px;
  height: 100px;
}

  }

 


  a{
    text-align:center;
  }


  h1{
    font-size: 2.3rem;
      line-height: 31px;
    font-weight: bold;
    font-family: 'Open Sans Condensed', sans-serif;

    margin: 0;

    ${up("md")}{
      font-size: 6.2rem;
      line-height: 84px;
}


  }
  h2{
    font-size: 18px;
    width: 80%;
    margin:0 auto;
  }
}

.goBagRequestSample {
  margin-top: 50px;

  &__result {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--selected-color);
    padding: 15px;

    & > hr {
      width: 100%;
      height: 1px;
      border: none;
      border-bottom: 1px dotted var(--selected-color);
    }

    & > img {
      width: 100%;
      object-fit: contain;
    }
  }

  &__form {
    input {
      font-size: 14px;
      text-align: left;
      line-height: 30px;
    }

    button {
      background-color: var(--selected-color);
      color: #fff;
      border-radius: 0;
      line-height: 30px;
    }
  }
}
`

export const Panel = styled.div`
  border-radius: 20px;
  background-color: var(--white-color);
  padding: 30px;
  margin-bottom: 30px;
  padding: 20px 13px;

  ${up("md")} {
    padding: 30px;
  }
`

export const AppContainer = styled.div`
  counter-reset: step;
  display: grid;
  height: 100%;

  grid-template-columns: auto;
  padding: 30px 0 0;

  ${up("lg")} {
    grid-template-columns: minmax(min-content, 220px) 1fr;
    padding: 30px 16px;
    grid-gap: 25px;
  }

  & > img {
    display: none;
    margin-top: 100px;

    ${up("lg")} {
      display: block;
    }
  }
`

export const Button = styled.button`
  border: 1px solid #2eace1;
  padding: 12px 28px;
  outline: none;
  text-transform: uppercase;
  background-color: ${(p) => (p.outline ? "transparent" : "#2EACE1")};
  color: ${(p) => (p.outline ? "#2EACE1" : "#fff")};
  transition: all linear 0.3s;
  font-family: "Open Sans Condensed", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 1.9rem;
  text-align: center;
  text-transform: uppercase;
  padding: 12px 21px;

  ${up("md")} {
    font-size: 2.2rem;
    line-height: 3rem;
    padding: 12px 28px;
  }

  :disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  :hover:not([disabled]) {
    cursor: pointer;
    background-color: ${(p) => (p.outline ? "#2EACE1" : "transparent")};
    color: ${(p) => (p.outline ? "#fff" : "#2EACE1")};
  }
`

export const ButtonRow = styled.div`
  display: grid;
  grid-gap: 21px;
  grid-template-columns: repeat(2, 1fr);
  position: absolute;
  align-items: center;
  transform: translateY(60px);

  ${up("md")} {
    position: static;
    transform: translateY(0);
    grid-gap: 30px;
  }
`

export default Panel
